import React, { Component } from 'react'
import { Modal, Button } from 'react-bootstrap'
import {reduxForm, Field} from 'redux-form'
import { Row, Col } from 'react-bootstrap'
import { required } from '../../util/validationFunctions'
import InputText from '../comun/form/InputText'
import InputTextArea from '../comun/form/InputTextArea'
import InputCheckBox from '../comun/form/InputCheckBox'
import './PanelControl.scss'
import {permisos as permisosConstant} from '../../constants/permisos'

class ModalTeclasContajePanelControl extends Component {
  componentDidMount() {
    this.props.actions.obtenerValoresTeclasContaje()
  }
  valoresPredefinidosTeclasContaje () {
    this.props.actions.valoresPredefinidosTeclasContaje()
  }
  obtenerValoresTeclasContaje () {
    this.props.actions.obtenerValoresTeclasContaje()
  }
  guardarTeclasContaje (values) {
    console.log(values)
    this.props.actions.guardarTeclasContaje(values)
  }
  render () {
    const {
      t, handleSubmit, showModalTeclasContaje, actions: {cerrarModalTeclasContaje}
    } = this.props
    return (
      <Modal show={showModalTeclasContaje} onHide={cerrarModalTeclasContaje} aria-labelledby="contained-modal-title-lg" className="modal-teclas-contaje" backdrop="static">
      <form className="form-teclas-contaje">
        <Modal.Header closeButton>
          <Modal.Title>
          {
            t('PANEL_CONTROL.MODAL_TECLAS_CONTAJE.TITLE')
          }
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col sm={4}></Col>
            <Col sm={4}><span className="teclaContajeMas">+</span></Col>
            <Col sm={4}><span className="teclaContajeMenos">-</span></Col>
            <Col sm={4}>
              <span>{t('PANEL_CONTROL.MODAL_TECLAS_CONTAJE.CABEZAS')}</span>
            </Col>
            <Field
              colSm={4}
              id="sumarCabezas"
              name="sumarCabezas"
              component={InputText}
              customClass='cabeza-mas'
              maxLength={true}
              valorMaxLength={1}
            />
            <Field
              colSm={4}
              id="restarCabezas"
              name="restarCabezas"
              component={InputText}
              customClass='cabeza-menos'
              maxLength={true}
              valorMaxLength={1}
            />
            <Col sm={4}>
              <span>{t('PANEL_CONTROL.MODAL_TECLAS_CONTAJE.COLAS')}</span>
            </Col>
            <Field
              colSm={4}
              id="sumarColas"
              name="sumarColas"
              component={InputText}
              customClass='colas-mas'
              maxLength={true}
              valorMaxLength={1}
            />
            <Field
              colSm={4}
              id="restarColas"
              name="restarColas"
              component={InputText}
              customClass='colas-menos'
              maxLength={true}
              valorMaxLength={1}
            />
            <Col sm={4}>
              <span>{t('PANEL_CONTROL.MODAL_TECLAS_CONTAJE.G_DISTAL')}</span>
            </Col>
            <Field
              colSm={4}
              id="sumarGotaDistal"
              name="sumarGotaDistal"
              component={InputText}
              customClass='g-distal-mas'
              maxLength={true}
              valorMaxLength={1}
            />
            <Field
              colSm={4}
              id="restarGotaDistal"
              name="restarGotaDistal"
              component={InputText}
              customClass='g-distal-menos'
              maxLength={true}
              valorMaxLength={1}
            />
            <Col sm={4}>
              <span>{t('PANEL_CONTROL.MODAL_TECLAS_CONTAJE.G_PROXIMAL')}</span>
            </Col>
            <Field
              colSm={4}
              id="sumarGotaProximal"
              name="sumarGotaProximal"
              component={InputText}
              customClass='g-proximal-mas'
              maxLength={true}
              valorMaxLength={1}
            />
            <Field
              colSm={4}
              id="restarGotaProximal"
              name="restarGotaProximal"
              component={InputText}
              customClass='g-proximal-menos'
              maxLength={true}
              valorMaxLength={1}
            />
            <Col sm={4}>
              <span>{t('PANEL_CONTROL.MODAL_TECLAS_CONTAJE.BUENOS')}</span>
            </Col>
            <Field
              colSm={4}
              id="sumarBuenos"
              name="sumarBuenos"
              component={InputText}
              customClass='buenos-mas'
              maxLength={true}
              valorMaxLength={1}
            />
            <Field
              colSm={4}
              id="restarBuenos"
              name="restarBuenos"
              component={InputText}
              customClass='buenos-menos'
              maxLength={true}
              valorMaxLength={1}
            />
            <Col sm={4}>
              <span>{t('PANEL_CONTROL.MODAL_TECLAS_CONTAJE.CUADROS')}</span>
            </Col>
            <Field
              colSm={4}
              id="sumarCuadros"
              name="sumarCuadros"
              component={InputText}
              customClass='cuadros-mas'
              maxLength={true}
              valorMaxLength={1}
            />
            <Field
              colSm={4}
              id="restarCuadros"
              name="restarCuadros"
              component={InputText}
              customClass='cuadros-menos'
              maxLength={true}
              valorMaxLength={1}
            />
            <Col sm={4}>
              <span>{t('PANEL_CONTROL.MODAL_TECLAS_CONTAJE.ACR_ANORMALES')}</span>
            </Col>
            <Field
              colSm={4}
              id="sumarAcrAnormales"
              name="sumarAcrAnormales"
              component={InputText}
              customClass='acr-anormales-mas'
              maxLength={true}
              valorMaxLength={1}
            />
            <Field
              colSm={4}
              id="restarAcrAnormales"
              name="restarAcrAnormales"
              component={InputText}
              customClass='acr-anormales-menos'
              maxLength={true}
              valorMaxLength={1}
            />
            <Col sm={4}>
              <span>{t('PANEL_CONTROL.MODAL_TECLAS_CONTAJE.VIDEOS')}</span>
            </Col>
            <Field
              colSm={4}
              id="sumarVideo"
              name="sumarVideo"
              component={InputText}
              customClass='video-mas'
              maxLength={true}
              valorMaxLength={1}
            />
            <Field
              colSm={4}
              id="restarVideo"
              name="restarVideo"
              component={InputText}
              customClass='video-menos'
              maxLength={true}
              valorMaxLength={1}
            />
            <Col sm={4}>
              <span>{t('PANEL_CONTROL.MODAL_TECLAS_CONTAJE.CONTADO')}</span>
            </Col>
            <Field
              colSm={4}
              id="sumarContado"
              name="sumarContado"
              component={InputText}
              customClass='contado-mas'
              maxLength={true}
              valorMaxLength={1}
            />
            <Field
              colSm={4}
              id="restarContado"
              name="restarContado"
              component={InputText}
              customClass='contado-menos'
              maxLength={true}
              valorMaxLength={1}
            />
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="button"
            className={"btn btn-white" + ((this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.TECLAS_CONTAJE] < 2) ? ' disabled' : '')}
            onClick={(this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.TECLAS_CONTAJE] > 1) ? () => this.valoresPredefinidosTeclasContaje() : undefined}
          >{t('PANEL_CONTROL.MODAL_TECLAS_CONTAJE.VALORES_PREDEFINIDOS')}</Button>
          <Button
            type="button"
            className={"btn btn-white" + ((this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.TECLAS_CONTAJE] < 2) ? ' disabled' : '')}
            onClick={(this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.TECLAS_CONTAJE] > 1) ? () => this.obtenerValoresTeclasContaje() : undefined}
          >{t('PANEL_CONTROL.MODAL_TECLAS_CONTAJE.VALORES_ANTERIORES')}</Button>
          <Button
            type="submit"
            className={"btn btn-primary" + ((this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.TECLAS_CONTAJE] < 2) ? ' disabled' : '')}
            onClick={(this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.TECLAS_CONTAJE] > 1) ? handleSubmit(this.guardarTeclasContaje.bind(this)) : undefined}
          >{t('PANEL_CONTROL.MODAL_TECLAS_CONTAJE.ACEPTAR')}</Button>
          <Button type="button" className="btn btn-white" onClick={cerrarModalTeclasContaje}>{t('PANEL_CONTROL.MODAL_TECLAS_CONTAJE.CERRAR')}</Button>
        </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default (reduxForm({
  form: 'ModalTeclasContajePanelControl',
})(ModalTeclasContajePanelControl))